module.exports = __webpack_public_path__ + "img/pro-jq.490547eb.png";